import cookies from "js-cookie";

export const clearLegacyCookieConsentPopupCookieValueIfExists = () => {
  const cookieName = "cookie-consent-key";
  const cookieValue = cookies.get(cookieName);
  if (cookieValue) {
    cookies.remove(cookieName);
  }
};

const LOCALE_COOKIE = "NEXT_LOCALE";

/**
 * Remembers the visitor's chosen language. Next.js reads `NEXT_LOCALE` on `/`
 * and redirects to that locale instead of guessing from Accept-Language.
 */
export const setLocaleCookie = (locale: string) => {
  cookies.set(LOCALE_COOKIE, locale, { expires: 365, sameSite: "lax" });
};
